/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
function isScreenSizeLarge() {
  if (window.PXUTheme.theme_settings.header_layout === 'classic') {
    return window.matchMedia('(min-width: 1024px)').matches;
  }
  return window.isScreenSizeLarge();
}
/* eslint-disable */
window.PXUTheme.jsHeader = {
  clearBindings: function() {
    $(document).off('.gpHeader');
    $(window).off('.gpHeader');
    $('#header, .navbar-item, .header__menu-toggle, .dropdown-click--true .header__link').off('.gpHeader');
    if (this.bodyOverlayClick) document.body.removeEventListener('click', this.bodyOverlayClick);
  },
  init: function($section) {
    this.clearBindings();

    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    if (this.header_layout === 'classic') {
      this.compactHeaderQuery?.removeEventListener('change', this.compactHeaderChange);
      this.compactHeaderQuery = window.matchMedia('(min-width: 1024px)');
      this.compactHeaderChange = () => {
        this.unload($section);
        if ($('body').hasClass('mobile-menu--opened')) window.PXUTheme.mobileMenu.close();
        window.PXUTheme.mobileMenu.disableSticky();
        this.init($section);
      };
      this.compactHeaderQuery.addEventListener('change', this.compactHeaderChange);
    }
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize.gpHeader', () => {
        if (isScreenSizeLarge()) {
          const latestAnnouncementHeight = $('.announcement-sticky-wrapper').height();
          this.enableSticky(latestAnnouncementHeight);
        } else {
          this.disableSticky();
        }
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click.gpHeader', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload(undefined, true);
      window.PXUTheme.mobileMenu.init();
    }

    $(document).on('click.gpHeader', '.search-overlay__close, [data-search-overlay-close]', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click.gpHeader',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click.gpHeader touchstart.gpHeader', function(e) {
        var $this = $(this);
        if (!$this.closest('.has-dropdown').children('.gp-submenu-toggle').length) window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave.gpHeader', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown.gpHeader', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      this.bodyOverlayClick = e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      };
      document.body.addEventListener('click', this.bodyOverlayClick);
    }
    const setSubmenu = (item, open) => {
      item.classList.toggle('is-opened', open);
      if (!open) delete item.dataset.gpClickOpened;
      item.querySelector(':scope > .gp-submenu-toggle')?.setAttribute('aria-expanded', String(open));
    };
    $(document).on('click.gpHeader', '.gp-submenu-toggle', function() {
      const item = this.closest('.has-dropdown');
      const open = item.dataset.gpClickOpened !== 'true';
      document.querySelectorAll('#header .has-dropdown').forEach(other => setSubmenu(other, false));
      setSubmenu(item, open);
      if (open) item.dataset.gpClickOpened = 'true';
    });
    $('#header .has-dropdown').on('mouseenter.gpHeader', function() {
      if (this.querySelector(':scope > .gp-submenu-toggle')) setSubmenu(this, true);
    }).on('mouseleave.gpHeader', function() {
      if (!this.contains(document.activeElement)) setSubmenu(this, false);
    }).on('focusout.gpHeader', function(event) {
      if (!this.contains(event.relatedTarget)) setSubmenu(this, false);
    }).on('keydown.gpHeader', function(event) {
      if (event.key !== 'Escape') return;
      const toggle = this.querySelector(':scope > .gp-submenu-toggle');
      if (!toggle) return;
      event.preventDefault();
      setSubmenu(this, false);
      toggle.focus();
    });
    $(window).on('click.gpHeader', function(event) {
      if ($(event.target).closest('.header__link, .navbar-dropdown, .gp-submenu-toggle').length) return;
      document.querySelectorAll('#header .has-dropdown').forEach(item => setSubmenu(item, false));
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
      $('.gp-submenu-toggle').attr('aria-expanded', 'false');
      window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
    });
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.parent().removeClass('sticky--scroll-up-only-hidden');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    $(window).off('scroll.headerScrollDirection');

    // Only force wrapper-height cleanup on mobile; desktop needs wrapper height to reserve page flow.
    if (!isScreenSizeLarge()) {
      setTimeout(function(){
        $stickyEl.css('height', 'auto');
        $stickyEl.parent('.header-sticky-wrapper').css('height', 'auto');
        $stickyEl.closest('[data-enable_sticky]').css('height', 'auto');
      }, 250);
    }
  },
  bindStickyScrollDirection: function() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    let threshold = 8;
    let minOffset = 120;
    let ticking = false;

    const updateStickyDirection = () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const scrollDelta = currentScrollTop - lastScrollTop;
      const $stickyWrapper = this.$el.parent('.header-sticky-wrapper');

      if (!$stickyWrapper.hasClass('is-sticky')) {
        lastScrollTop = currentScrollTop;
        ticking = false;
        return;
      }

      if (Math.abs(scrollDelta) <= threshold) {
        ticking = false;
        return;
      }

      if (scrollDelta > 0 && currentScrollTop > minOffset) {
        $stickyWrapper.addClass('sticky--scroll-up-only-hidden');
      } else {
        $stickyWrapper.removeClass('sticky--scroll-up-only-hidden');
      }

      lastScrollTop = currentScrollTop;
      ticking = false;
    };

    $(window).off('scroll.headerScrollDirection').on('scroll.headerScrollDirection', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyDirection);
        ticking = true;
      }
    });
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;
    if (!isScreenSizeLarge()) {
      this.disableSticky();
      return;
    }

    // Clear stale inline heights before re-enabling sticky on desktop.
    $stickyEl.css('height', '');
    $stickyEl.parent('.header-sticky-wrapper').css('height', '');
    $stickyEl.closest('[data-enable_sticky]').css('height', '');

    $stickyEl.addClass('sticky--enabled');
    this.bindStickyScrollDirection();

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .off('sticky-start.gpHeader sticky-end.gpHeader')
    .on('sticky-start.gpHeader', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end.gpHeader', () => {
      $stickyEl.parent().removeClass('sticky--scroll-up-only-hidden');
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      var siteOverlayEl = document.querySelector('[data-site-overlay]');
      if (siteOverlayEl) siteOverlayEl.classList.remove('site-overlay--hidden');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      var siteOverlay = document.querySelector('[data-site-overlay]');
      if (siteOverlay) siteOverlay.classList.add('site-overlay--hidden');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').on('mouseenter.gpHeader', function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section, keepBreakpoint) {
    this.clearBindings();
    if (!keepBreakpoint) this.compactHeaderQuery?.removeEventListener('change', this.compactHeaderChange);
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    this.$menuToggle?.off('.gpHeader');
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;
